export const getAudioMetaData = (src) => {
    return new Promise((resolve) => {
        const audio = document.createElement("audio");
        audio.src = src;

        audio.addEventListener("loadedmetadata", () => {
            resolve(audio);
        });
    });
};